import { render, staticRenderFns } from "./Tuile.vue?vue&type=template&id=8d740652"
import script from "./Tuile.vue?vue&type=script&lang=js"
export * from "./Tuile.vue?vue&type=script&lang=js"
import style0 from "./Tuile.vue?vue&type=style&index=0&id=8d740652&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports